import React, { useState, useEffect, useContext } from "react";
import Adding2Archive from "../../../Modals/Adding2Archive/Adding2Archive";
import { AuthContext } from "../../../../context/authContext";
import API from "../../../../Functions/API/api";
import LoadingPage from '../../../../Error/LoadingPage/LoadingPage'

const ProblemArchive = () => {
  const [Search, setSearch] = useState("");
  const [AddingModal, setAddingModal] = useState(false);
  const { user } = useContext(AuthContext);

  const [problems, setProblems] = useState([]);
  const [loading, setLoading] = useState(true); // NEW state for loading

  useEffect(() => {
    const fetchProblems = async () => {
      try {
        const res = await API.get("/archive");
        setProblems(res.data);
      } catch (err) {
        console.error("Error fetching problems:", err);
      } finally {
        setLoading(false); // stop loading once finished

      }
    };

    fetchProblems();
  }, []);

  if (loading) {return <LoadingPage/>}
if (problems.length===0){
  return (<div><div className="Archive-Table-Search"><h1>Problems Archive :</h1> {user?.role.toLowerCase() === "admin" ? (
          <button onClick={() => setAddingModal(true)}>Add to Archive</button>
        ) : null}</div>
  <p className="error">No data is available at the moment ...</p>
  </div>)
}
  return (
    <div>
      <div className="Archive-Table-Search">
        <h1>Problems Archive :</h1>
        {user?.role.toLowerCase() === "admin" ? (
          <button onClick={() => setAddingModal(true)}>Add to Archive</button>
        ) : null}

        <select
          id="typeFilter"
          className="type-select"
          onChange={(e) => setSearch(e.target.value)}
        >
          <option value="">Filter by Type</option>
          <option value="Marathon">Marathon</option>
          <option value="Training Test">Training Test</option>
          <option value="Mock Contest">Mock Contest</option>
          <option value="Challenge">Challenge</option>
          <option value="Weekly Problem Set">Weekly Problem Set</option>
        </select>
      </div>

      <div className="table-container">
        {loading ? (
          <p>Loading...</p> // Show while fetching data
        ) : (
          <table className="archive-table">
            <thead>
              <tr>
                <th>Type</th>
                <th>Subject</th>
                <th>Added By</th>
                <th>Date</th>
                <th>Paper</th>
              </tr>
            </thead>
            <tbody>
              {[...problems]
                /* .sort((a, b) => {
                  const bDuration =
                    parseInt(b.Date.slice(0, 2), 10) +
                    parseInt(b.Date.slice(3, 5), 10) * 30 +
                    parseInt(b.Date.slice(6), 10) * 3600;
                  const aDuration =
                    parseInt(a.Date.slice(0, 2), 10) +
                    parseInt(a.Date.slice(3, 5), 10) * 30 +
                    parseInt(a.Date.slice(6), 10) * 3600;

                  return bDuration - aDuration;
                }) */
                .filter((el) => el.type.includes(Search))
                .map((item, index) => (
                  <tr key={index}>
                    <td>{item?.type}</td>
                    <td>{item?.subject}</td>
                    <td>{item?.author}</td>
                    <td>{item?.date}</td>
                    <td>
                      <a href={item?.paper} download>
                        Download
                      </a>
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
        )}
      </div>

      {AddingModal === true ? (
        <Adding2Archive setAddingModal={setAddingModal} />
      ) : null}
    </div>
  );
};

export default ProblemArchive;
